export const isString = (input) => input != null && typeof input === 'string';
export const equalsIgnoreCase = (str1, str2) => {
  if (!isString(str1) || !isString(str2)) return null;
  return str1.toLowerCase() === str2.toLowerCase();
};
export const JSONParse = (string, defaultValue = null) => {
  if (!isString(string)) return defaultValue;
  try {
    return JSON.parse(string);
  } catch (error) {
    return defaultValue;
  }
};
export const urlDecode = (encodedString) => {
  if (!isString(encodedString)) {
    throw new Error('Invalid URL encoding');
  }
  return decodeURIComponent(encodedString);
};
export const formatParams = (params) =>
  Object.keys(params)
    .map(
      (key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    )
    .join('&');
export const normalizeString = (str, replaceCharacter = '') => {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, replaceCharacter);
};
/**
 * @param {string} str
 * @return {string}
 */
export const normalizeStringAlphabeltOnly = (str) => {
  if (str == null) return ''; // Handle null/undefined

  return str
    ?.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/[^a-z0-9\s]/g, '') // Remove non-alphanumeric except space
    .replace(/\s+/g, ' ') // Collapse multiple spaces
    .trim();
};
/**
 * @param {string} str1
 * @param {string} str2
 * @return {boolean}
 */
export const isEqualNormalizedString = (str1, str2) => {
  if (!isString(str1) || !isString(str2)) {
    return false;
  }

  const normalizedStr1 = normalizeString(str1);
  const normalizedStr2 = normalizeString(str2);

  return normalizedStr1 === normalizedStr2;
};

/**
 * @param {string} str1
 * @param {string} str2
 * @return {boolean}
 */
export const isNormalizedStringEndsWith = (str1, str2) => {
  if (!isString(str1) || !isString(str2)) {
    return false;
  }

  const normalizedStr1 = normalizeString(str1);
  const normalizedStr2 = normalizeString(str2);

  return normalizedStr1.endsWith(normalizedStr2);
};

/**
 * @param {string} str1
 * @param {string} str2
 * @return {boolean}
 */
export const isNormalizedStringIncludes = (str1, str2) => {
  if (!isString(str1) || !isString(str2)) {
    return false;
  }

  const normalizedStr1 = normalizeString(str1);
  const normalizedStr2 = normalizeString(str2);

  return normalizedStr1.includes(normalizedStr2);
};
